var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle00A = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 48",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M0 2.5A2.5 2.5 0 0 1 2.5 0h23A2.5 2.5 0 0 1 28 2.5v43a2.5 2.5 0 0 1-2.5 2.5h-23A2.5 2.5 0 0 1 0 45.5v-43Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 2.5A2.5 2.5 0 0 1 2.5 0h23A2.5 2.5 0 0 1 28 2.5v43a2.5 2.5 0 0 1-2.5 2.5h-23A2.5 2.5 0 0 1 0 45.5v-43Z"
})));
SvgRectangle00A.viewBox = '0 0 28 48';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle00A);
export default ForwardRef;